import { retrieve } from 'putki';
import type { FeatureName } from 'routes/featureNames';

export function isFeatureEnabled(name: FeatureName): boolean {
  const enabledFeatures = retrieve('enabled_features');
  if (Array.isArray(enabledFeatures)) {
    return enabledFeatures.includes(name);
  }
  return false;
}
